import { render, staticRenderFns } from "./LandingView.vue?vue&type=template&id=c66c05b4&scoped=true"
import script from "./LandingView.vue?vue&type=script&lang=js"
export * from "./LandingView.vue?vue&type=script&lang=js"
import style0 from "./LandingView.vue?vue&type=style&index=0&id=c66c05b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66c05b4",
  null
  
)

export default component.exports